import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Subject } from 'rxjs';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query searchLocationSectors($where: LocationSectorWhereInput, $limit: Int, $offset: Int) {\n    locationSectors(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query searchLocationSectors($where: LocationSectorWhereInput, $limit: Int, $offset: Int) {\n    locationSectors(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"])));
var FcLocationSectorInputComponent = /** @class */ (function () {
    function FcLocationSectorInputComponent(fuseTranslationLoaderService, apollo) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.apollo = apollo;
        this.showSearchIcon = false;
        this.requiredMark = false;
        this.preloadOptions = false;
        this.searchOnFocus = false;
        this.enableInfiniteScroll = true;
        this.showChevronIcon = false;
        this.reload$ = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcLocationSectorInputComponent.prototype.search = function (searchTerm, limit, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.locationId) {
                    return [2 /*return*/];
                }
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_QUERY,
                        variables: {
                            where: {
                                locationId: this.locationId,
                                nameContains: searchTerm,
                                archived: false
                            },
                            limit: limit,
                            offset: offset
                        },
                    })
                        .toPromise()
                        .then(function (result) {
                        return result.data['locationSectors']['items'];
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcLocationSectorInputComponent.prototype.displayWith = function (value) {
        return value && value.name;
    };
    return FcLocationSectorInputComponent;
}());
export { FcLocationSectorInputComponent };
var templateObject_1;
